import { Pipe, PipeTransform } from '@angular/core';
import { isDefined, Maybe } from '@stillmandigital/common';
import { ReferralAgentActionType } from 'app/settings/store/referral-agents/referral-agents.interfaces';

const actionTypeText: { [key in ReferralAgentActionType]: string } = {
  create: 'Create Referral Agent',
  update: 'Update Referral Agent',
  link: 'Link Account to Referral Agent',
};

@Pipe({
  standalone: true,
  name: 'referralAgentActionType',
})
export class ReferralAgentActionTypePipe implements PipeTransform {
  public transform(value: Maybe<ReferralAgentActionType>): unknown {
    return isDefined(value) ? actionTypeText[value] : '';
  }
}
